import React from 'react';
import { motion } from 'framer-motion';
import { IMAGES } from '../data/content';
import { CTAButton } from './CTAButton';
export function Hero() {
  return <header className="relative w-full bg-navy text-white" data-id="element-145" data-mp="ei1w7odj86z0">
      <div className="bg-teal px-4 py-2 text-center text-xs font-bold uppercase tracking-wider text-navy-deep sm:text-sm" data-id="element-146" data-mp="9ll8uwe5pwmz">
        Educational resource for dental professionals
      </div>
      <div className="mx-auto grid max-w-6xl gap-8 px-4 pb-14 pt-8 md:grid-cols-2 md:items-center md:gap-12 md:pb-20 md:pt-14" data-id="element-147" data-mp="128fq7kfogfw8">
        <div className="text-center md:text-left" data-id="element-148" data-mp="xb5s7ge82vws">
          <p className="font-display text-lg font-bold uppercase tracking-wide text-teal-light" data-id="element-149" data-mp="sartioyigybf">
            Pediatric Orthodontic Case Decision Blueprint™
          </p>
          <h1 className="mt-3 font-display text-[2.7rem] font-extrabold uppercase leading-[0.95] sm:text-6xl lg:text-7xl" data-id="element-150" data-mp="nekkuoeqd8ps">
            Evaluate Pediatric Orthodontic Cases in <span className="text-gold" data-id="element-151" data-mp="380vyhwiiarcm">15 Minutes</span>
          </h1>
          <p className="mt-4 text-lg font-semibold text-white/90 sm:text-xl" data-id="element-152" data-mp="3j898df6ywfql">
            With a Structured Clinical Decision Framework
          </p>
          <p className="mt-5 inline-block rounded-xl bg-white/10 px-4 py-3 text-lg font-bold" data-id="element-153" data-mp="3o5j2v997rhla">
            Stop second-guessing your next pediatric orthodontic case.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="-mx-4 md:mx-0 md:row-span-2" data-id="element-154" data-mp="3ebirwqr93i4n">
          <img src={IMAGES.mockup} alt="Pediatric Orthodontic Case Decision Blueprint: 6 volumes and 5 bonus resources" className="w-full drop-shadow-[0_25px_40px_rgba(0,0,0,0.45)]" data-id="element-155" data-mp="2qkdc2blb8puc" />
        </motion.div>

        <div className="text-center md:text-left" data-id="element-156" data-mp="2hjyo14gyown5">
          <p className="text-base leading-relaxed text-white/80 sm:text-lg" data-id="element-157" data-mp="2lla52llrs9jq">
            A practical, evidence-informed clinical reference to help you organize your diagnostic findings, compare
            treatment alternatives, and make more structured decisions when evaluating children and adolescents.
          </p>
          <p className="mt-4 text-lg font-semibold" data-id="element-158" data-mp="id9r45wihxq4">
            Inside: <span className="text-gold" data-id="element-159" data-mp="ddf2ya44fm8r">6 specialized volumes</span> +{' '}
            <span className="text-gold" data-id="element-160" data-mp="db2f5gbomhns">5 exclusive clinical bonuses</span>.
          </p>
          <CTAButton id="first-cta" className="mt-7 md:items-start" label="See all 6 volumes + 5 bonuses" subtext="Instant digital access · One-time payment of $27 USD · Lifetime access" tone="dark" data-id="element-161" data-mp="1b049mx9rqn0y" />
          <p className="mt-6 text-xs leading-relaxed text-white/50" data-id="element-162" data-mp="x0crckc7ykh5">
            The 15-minute target refers to organizing an initial case review using the framework, not completing a
            diagnosis or treatment plan for every patient. Actual evaluation time varies with case complexity.
          </p>
        </div>
      </div>
    </header>;
}